import { render } from "./HelpBar.vue?vue&type=template&id=56981a01&scoped=true"
import script from "./HelpBar.vue?vue&type=script&lang=js"
export * from "./HelpBar.vue?vue&type=script&lang=js"

import "./HelpBar.vue?vue&type=style&index=0&id=56981a01&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56981a01"]])

export default __exports__